// @ts-nocheck
import { populate } from 'populate';
import type { Container, TilingSprite, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: '5a7b5f7e-ba03-499a-9de8-29554aed9a08',
      type: 'Container',
      name: 'root',
      className: 'props_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        props: {
          eventMode: 'none'
        }
      },
      interactiveChildren: false
    },
    {
      id: 'f8e898a1-4bd4-4507-adfe-6077e85ad109',
      type: 'Sprite',
      name: '',
      className: '',
      x: 780,
      y: -1280,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '4_Season_Pass_Screen_2',
      parent: '5a7b5f7e-ba03-499a-9de8-29554aed9a08',
      data: {
        DEBUG: true
      }
    },
    {
      id: 'a1cfa629-130d-44ee-bec5-97dd51486e2a',
      type: 'Container',
      name: 'background',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5a7b5f7e-ba03-499a-9de8-29554aed9a08'
    },
    {
      id: 'd546d675-b1b8-4c32-8c3b-af2a8cc89808',
      type: 'Container',
      name: 'widget',
      className: '',
      x: 0,
      y: 157,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5a7b5f7e-ba03-499a-9de8-29554aed9a08'
    },
    {
      id: 'b7c87291-0b48-4abd-b2ad-ab4427240e34',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 9,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 26.666667,
        y: 1.886792
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Premium_Column_Background',
      parent: 'a1cfa629-130d-44ee-bec5-97dd51486e2a'
    },
    {
      id: '2c43f5ac-3df8-487a-bf9b-1a9a4d0e0ac4',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 80,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Thick_Separation',
      parent: 'a1cfa629-130d-44ee-bec5-97dd51486e2a'
    },
    {
      id: '035762aa-3fe5-436e-b78c-5ab9a54e5ae6',
      type: 'Sprite',
      runtimeType: 'TilingSprite',
      name: '',
      className: '',
      x: -400,
      y: 19,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 8.163265,
        y: 4.022989
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 4327558,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Season_Pass_Key_Pattern',
      parent: 'a1cfa629-130d-44ee-bec5-97dd51486e2a'
    },
    {
      id: 'c18b35d7-d6e1-4940-8879-77e3f636e592',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -315,
      y: -119,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 630,
      height: 265,
      leftWidth: 130,
      topHeight: 0,
      rightWidth: 130,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Season_Pass_Vault_Background_3Slice_132x132',
      parent: 'd546d675-b1b8-4c32-8c3b-af2a8cc89808'
    },
    {
      id: 'e81c3de0-644e-4ca2-93b7-f65d88ff4dc5',
      type: 'Container',
      name: 'safeContainer',
      className: '',
      x: 180,
      y: 19,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'd546d675-b1b8-4c32-8c3b-af2a8cc89808'
    },
    {
      id: 'fde7a221-0367-4c3a-9adb-50b346d9d0ab',
      type: 'Sprite',
      name: '',
      className: '',
      x: -59,
      y: 52,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Timer_Background',
      parent: 'd546d675-b1b8-4c32-8c3b-af2a8cc89808'
    },
    {
      id: 'dd5ba0b9-6362-4578-907b-bd73f58c4e3c',
      type: 'Sprite',
      name: '',
      className: '',
      x: -44,
      y: 80,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Vault_Coin_Icon',
      parent: 'd546d675-b1b8-4c32-8c3b-af2a8cc89808'
    },
    {
      id: 'b26b35d9-2780-4ef2-8a90-27b0e69d7e2d',
      type: 'Sprite',
      name: 'titleHighlight',
      className: '',
      x: -184,
      y: -92,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.288793,
        y: 0.443966
      },
      angle: -24,
      alpha: 0,
      visible: true,
      tint: 16439881,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: 'd546d675-b1b8-4c32-8c3b-af2a8cc89808'
    },
    {
      id: '176f232c-08bc-4a2d-87e9-79a8c8d15fbf',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: -93,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Premium Season Vault',
      localize: true,
      maxWidth: 390,
      maxHeight: 59,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 35,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#7E2D2A',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#FFED81',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'd546d675-b1b8-4c32-8c3b-af2a8cc89808'
    },
    {
      id: 'd7854948-796c-4168-85cb-caa3fb286cb6',
      type: 'Text',
      name: '',
      className: '',
      x: -89,
      y: 77,
      anchor: {
        x: 1,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Current Total:',
      localize: true,
      maxWidth: 199,
      maxHeight: 54,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 29,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 0,
        dropShadowBlur: 4,
        dropShadowColor: 'black',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'd546d675-b1b8-4c32-8c3b-af2a8cc89808'
    },
    {
      id: 'c83b6b27-d090-451f-a702-95c556be4479',
      type: 'Text',
      name: 'amountText',
      className: '',
      x: 52,
      y: 79,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'XXX',
      localize: false,
      maxWidth: 119,
      maxHeight: 54,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#751D59',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 0,
        dropShadowBlur: 4,
        dropShadowColor: 'black',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'd546d675-b1b8-4c32-8c3b-af2a8cc89808'
    },
    {
      id: 'fb7a765a-cf22-4659-8be6-6ce159b8b76d',
      type: 'Text',
      name: 'descriptionText',
      className: '',
      x: -96,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'seasonPassVaultDescription',
      localize: true,
      maxWidth: 350,
      maxHeight: 91,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 350,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 0,
        dropShadowBlur: 4,
        dropShadowColor: 'black',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'd546d675-b1b8-4c32-8c3b-af2a8cc89808'
    },
    {
      id: '4bf425ae-c2bd-4bbd-8e52-33098ffe2495',
      type: 'Container',
      name: 'sparksContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'd546d675-b1b8-4c32-8c3b-af2a8cc89808'
    },
    {
      id: '427dc36f-f72c-485a-aa49-38e612805236',
      type: 'Sprite',
      name: 'safeBlurCircle',
      className: '',
      x: 0,
      y: 10,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.35,
        y: 0.9
      },
      angle: 0,
      alpha: 0.5,
      visible: true,
      tint: 16439881,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: 'e81c3de0-644e-4ca2-93b7-f65d88ff4dc5'
    },
    {
      id: '118077f6-8ccf-42d2-aeb4-c23447d21d13',
      type: 'Sprite',
      name: '',
      className: 'rotate_SPL',
      x: 2,
      y: -10,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.35,
        y: 0.35
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16439881,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ray',
      parent: 'e81c3de0-644e-4ca2-93b7-f65d88ff4dc5'
    },
    {
      id: '9d1c84a3-7368-49be-a726-ff486fd38f3d',
      type: 'Sprite',
      name: '',
      className: 'rotate_SPL',
      x: 13,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 15,
      alpha: 1,
      visible: true,
      tint: 16439881,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: 'e81c3de0-644e-4ca2-93b7-f65d88ff4dc5',
      data: {
        rotationCycle: 27000
      }
    },
    {
      id: '97a89f22-bc7c-4b29-89b9-43329c15d956',
      type: 'Sprite',
      name: '',
      className: '',
      x: 8,
      y: 67,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.181034,
        y: 0.698276
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 2636707,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: 'e81c3de0-644e-4ca2-93b7-f65d88ff4dc5'
    },
    {
      id: '29acb908-d527-4eee-aaef-dfb119f9afa4',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 65,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.181034,
        y: 0.293103
      },
      angle: 0,
      alpha: 0.2,
      visible: true,
      tint: 0,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: 'e81c3de0-644e-4ca2-93b7-f65d88ff4dc5'
    },
    {
      id: '21d7d3cc-d970-4099-aede-d4d27c44e933',
      type: 'Sprite',
      name: 'safeIcon',
      className: '',
      x: 0,
      y: 74,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Season_Pass_Vault_Icon',
      parent: 'e81c3de0-644e-4ca2-93b7-f65d88ff4dc5'
    },
    {
      id: 'd77665c9-49e2-473f-8dba-33e37c94cbd4',
      type: 'Sprite',
      name: 'part1',
      className: '',
      x: 246,
      y: -33,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'particle_shine_1_small_white',
      parent: '4bf425ae-c2bd-4bbd-8e52-33098ffe2495'
    },
    {
      id: 'fa836f1a-cdca-4123-bf80-c747fa339c7d',
      type: 'Sprite',
      name: 'part2',
      className: '',
      x: 239,
      y: -115,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'particle_shine_1_small_white',
      parent: '4bf425ae-c2bd-4bbd-8e52-33098ffe2495'
    },
    {
      id: '752fc8c6-7498-4b51-a077-5d522f798cf3',
      type: 'Sprite',
      name: 'part3',
      className: '',
      x: 155,
      y: 11,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'particle_shine_1_small_white',
      parent: '4bf425ae-c2bd-4bbd-8e52-33098ffe2495'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  animations: [
    {
      id: 'd9b4c922-ef35-4d44-b236-4dbabcb10512',
      name: 'Idle_SafeBackground_1',
      playingSpeed: 1,
      totalDuration: 1800,
      blocks: [
        {
          id: 'e25bddfc-f11e-4ef4-b5ae-85489927a750',
          type: 'Tween',
          name: 'New_tween',
          duration: 900,
          track: 2,
          target: {
            scale: {
              x: 1.67
            }
          },
          startAt: 0,
          sourceName: 'safeBlurCircle',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '6f0089ea-c6de-43ee-9190-a3068ee20ab9',
          type: 'Tween',
          name: 'New_tween_copy',
          duration: 900,
          track: 2,
          target: {
            scale: {
              x: 1.35
            }
          },
          startAt: 900,
          sourceName: 'safeBlurCircle',
          easing: 'SinusoidalInOut',
          disabled: false
        }
      ]
    },
    {
      id: '2d02239e-fc7e-4f03-9f25-248859b30d24',
      name: 'Idle_TitleHighlight',
      playingSpeed: 1,
      totalDuration: 6000,
      blocks: [
        {
          id: 'c481b25c-58a9-4f19-a057-13164d9bf96d',
          type: 'Setter',
          name: 'New_setter',
          track: 1,
          target: {
            x: -184,
            y: -92,
            angle: -24
          },
          startAt: 0,
          sourceName: 'titleHighlight',
          disabled: false
        },
        {
          id: '444a239e-4206-4fce-a392-2436506b74c5',
          type: 'Tween',
          name: 'New_tween_1',
          duration: 500,
          track: 2,
          target: {
            alpha: 0.2
          },
          startAt: 0,
          sourceName: 'titleHighlight',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '17774fd8-e772-4f20-b0ac-f1bf86a55fc4',
          type: 'Tween',
          name: 'New_tween_2',
          duration: 3000,
          track: 3,
          target: {
            x: 171,
            angle: 24
          },
          startAt: 2,
          sourceName: 'titleHighlight',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: '767aee86-0576-464e-bf02-965b6cf501eb',
          type: 'Tween',
          name: 'New_tween_1_copy',
          duration: 1000,
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 2000,
          sourceName: 'titleHighlight',
          easing: 'Linear',
          disabled: false
        }
      ]
    },
    {
      id: 'b9f32e76-9e7e-4b4e-a048-df99abbd6155',
      name: 'Idle_Sparks',
      playingSpeed: 1,
      totalDuration: 8000,
      blocks: [
        {
          id: '3f39b07f-af09-45d9-b9d4-af0fc5adaa03',
          type: 'Setter',
          name: 'partSetter',
          track: 5,
          target: {
            angle: 0
          },
          startAt: 0,
          sourceName: 'part1',
          disabled: false
        },
        {
          id: 'b782d30f-19c6-4e78-b9b5-988f58beb1b4',
          type: 'Setter',
          name: 'partSetter_copy',
          track: 7,
          target: {
            angle: 0
          },
          startAt: 0,
          sourceName: 'part2',
          disabled: false
        },
        {
          id: '17931dbf-13f0-4a03-b301-d5d0fe75d8f5',
          type: 'Setter',
          name: 'partSetter_copy_copy',
          track: 6,
          target: {
            angle: 0
          },
          startAt: 0,
          sourceName: 'part3',
          disabled: false
        },
        {
          id: 'f5d86046-d9a1-4886-9b44-b89eafe4ec47',
          type: 'Tween',
          name: 'partRotation',
          duration: 8000,
          track: 3,
          target: {
            angle: 360
          },
          startAt: 0,
          sourceName: 'part1',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '9e32681a-5d86-4098-bbb4-f6417bc4f7ff',
          type: 'Tween',
          name: 'partRotation_copy',
          duration: 8000,
          track: 2,
          target: {
            angle: 360
          },
          startAt: 0,
          sourceName: 'part2',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '69b63fa1-ea79-4e29-bade-6a03cfeaab80',
          type: 'Tween',
          name: 'partRotation_copy_1',
          duration: 8000,
          track: 1,
          target: {
            angle: 360
          },
          startAt: 0,
          sourceName: 'part3',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '7d36989b-6adf-489f-8b5d-0aad4429d3c4',
          type: 'Tween',
          name: 'partIn',
          duration: 600,
          track: 7,
          target: {
            alpha: 0.7
          },
          startAt: 315,
          sourceName: 'part1',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '472f0530-0de9-4728-90c7-0122a3362b47',
          type: 'Tween',
          name: 'partOut',
          duration: 400,
          track: 7,
          target: {
            alpha: 0
          },
          startAt: 1070,
          sourceName: 'part1',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: '55dfc6ce-dc6b-44fe-8858-4ba851cdce60',
          type: 'Tween',
          name: 'partIn_copy',
          duration: 600,
          track: 5,
          target: {
            alpha: 0.7
          },
          startAt: 2036,
          sourceName: 'part2',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '2f277760-3392-4aa9-9a4c-b6f32b806024',
          type: 'Tween',
          name: 'partOut_copy',
          duration: 400,
          track: 5,
          target: {
            alpha: 0
          },
          startAt: 2845,
          sourceName: 'part2',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: '197b3995-2086-4fde-9efe-58b3adf68a2e',
          type: 'Tween',
          name: 'partIn_copy_copy',
          duration: 600,
          track: 4,
          target: {
            alpha: 0.7
          },
          startAt: 4198,
          sourceName: 'part3',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '196db0c4-c18e-41aa-927c-dced900bd897',
          type: 'Tween',
          name: 'partOut_copy_copy',
          duration: 400,
          track: 4,
          target: {
            alpha: 0
          },
          startAt: 5003,
          sourceName: 'part3',
          easing: 'SinusoidalOut',
          disabled: false
        }
      ]
    },
    {
      id: '7f027f25-2d86-421e-b7a3-56bcd804060f',
      name: 'Idle_SafeBreathing',
      playingSpeed: 1,
      totalDuration: 2000,
      blocks: [
        {
          id: 'c9e52650-f6d2-4c07-94ff-3ede2980e72c',
          type: 'Tween',
          name: 'New_tween_3',
          duration: 1000,
          track: 2,
          target: {
            scale: {
              x: 0.99,
              y: 1.01
            }
          },
          startAt: 0,
          sourceName: 'safeIcon',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '2e688903-9b3b-4ba1-9473-dc999aae9749',
          type: 'Tween',
          name: 'New_tween_3_copy',
          duration: 1000,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1000,
          sourceName: 'safeIcon',
          easing: 'Linear',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class SeasonPassVaultLayout {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  background!: Container;
  widget!: Container;
  safeContainer!: Container;
  titleHighlight!: Sprite;
  amountText!: Text;
  descriptionText!: Text;
  sparksContainer!: Container;
  safeBlurCircle!: Sprite;
  safeIcon!: Sprite;
  part1!: Sprite;
  part2!: Sprite;
  part3!: Sprite;
  props_SPL!: (Container & { data: typeof raw['list'][0]['data'] })[];
  rotate_SPL!: (Sprite | Sprite & { data: typeof raw['list'][19]['data'] })[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Idle_SafeBackground_1 {
  Layout: {
    safeBlurCircle: object;
  };

  BlockTypeByName: {
    New_tween: object;
    New_tween_copy: object;
  };

  flowData = raw.animations[0];
}

export abstract class Idle_TitleHighlight {
  Layout: {
    titleHighlight: object;
  };

  BlockTypeByName: {
    New_setter: object;
    New_tween_1: object;
    New_tween_2: object;
    New_tween_1_copy: object;
  };

  flowData = raw.animations[1];
}

export abstract class Idle_Sparks {
  Layout: {
    part1: object;
    part2: object;
    part3: object;
  };

  BlockTypeByName: {
    partSetter: object;
    partSetter_copy: object;
    partSetter_copy_copy: object;
    partRotation: object;
    partRotation_copy: object;
    partRotation_copy_1: object;
    partIn: object;
    partOut: object;
    partIn_copy: object;
    partOut_copy: object;
    partIn_copy_copy: object;
    partOut_copy_copy: object;
  };

  flowData = raw.animations[2];
}

export abstract class Idle_SafeBreathing {
  Layout: {
    safeIcon: object;
  };

  BlockTypeByName: {
    New_tween_3: object;
    New_tween_3_copy: object;
  };

  flowData = raw.animations[3];
}
